import { useApolloClient } from '@apollo/client';
import { useActionsStore } from '../../integrations/lavva/store/actions';
import { useCacheStore } from '../../integrations/lavva/store/cache';
import { useChannelsStore } from '../../integrations/lavva/store/channels';
import { useDevicesStore } from '../../integrations/lavva/store/devices';
import { useGroupsStore } from '../../integrations/lavva/store/groups';
import { useInstallationsStore } from '../../store/installations';

export const useRefetchData = () => {
  const apolloClient = useApolloClient();
  const { setGroupsSkip, setActionsSkip, setInstallationsSkip } = useCacheStore((s) => s);
  const refetchActions = useActionsStore((s) => s.refetchActions);
  const refetchGroups = useGroupsStore((s) => s.refetchGroups);
  const refetchInstallations = useInstallationsStore((s) => s.refetchInstallations);
  const refetchChannels = useChannelsStore((s) => s.refetchChannels);
  const refetchDevices = useDevicesStore((s) => s.refetchDevices);

  const checkIfCanFetch = (queryName: string) => {
    const mapOfActiveQueries = apolloClient.getObservableQueries();

    const activeQueries = Array.from(mapOfActiveQueries)
      .map((subArray) => subArray[1].queryName || '')
      .filter((x) => x);

    return activeQueries.find((x) => x === queryName);
  };

  const refetchChannelDetails = async () => {
    if (checkIfCanFetch('ChannelsDetails')) {
      apolloClient.cache.evict({
        id: 'ROOT_QUERY',
        fieldName: 'userChannel',
      });
      apolloClient.cache.gc();

      return await apolloClient.refetchQueries({ include: ['ChannelsDetails'] });
    }
  };

  const refetchAll = async () => {
    setGroupsSkip(false);
    setActionsSkip(false);
    setInstallationsSkip(false);

    refetchInstallations();
    refetchDevices();
    refetchChannels();
    refetchGroups();
    refetchActions();
  };

  return {
    refetchDevices,
    refetchChannels,
    refetchGroups,
    refetchActions,
    refetchChannelDetails,
    refetchInstallations,
    refetchAll,
  };
};
